import * as yup from 'yup'

export const schema = {
  sender: '',
  recipient: '',
  message: ''
}

export const validation = () => {
  return (
    yup
      .object()
      .shape({
        sender: yup
          .string(),

        recipient: yup
          .string(),

        message: yup
          .string()
      })
  )
}
